import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { paths } from '../../routes/paths';
import styles from './AuthCallbackPage.module.css';

// Lands here after OAuth redirect. Visual: terminal log.
export default function AuthCallbackPage() {
  const { completeLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [step, setStep] = useState(0);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (!accessToken) {
      setError('no token received from provider');
      return;
    }

    setStep(1);
    completeLogin({ accessToken, refreshToken }).then(() => {
      setStep(2);
      setTimeout(() => navigate(paths.workspaces, { replace: true }), 350);
    });
  }, [completeLogin, navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.terminal}>
        <div className={styles.header}>[ sabia // auth_callback ]</div>
        <div className={styles.log}>
          <div>&gt; reading oauth fragment...</div>
          {step >= 1 && <div>&gt; token received <span className={styles.ok}>[OK]</span></div>}
          {step >= 1 && <div>&gt; authenticating session...</div>}
          {step >= 2 && <div>&gt; session active <span className={styles.ok}>[OK]</span></div>}
          {step >= 2 && <div>&gt; redirecting to /workspaces<span className={styles.caret}>_</span></div>}
          {error && (
            <div className={styles.err}>! error: {error}</div>
          )}
          {!error && step < 2 && (
            <div>&gt; <span className={styles.caret}>_</span></div>
          )}
        </div>
      </div>
    </div>
  );
}
